import { Hint } from '@factorialco/deprecated-design-system'
import { LOCAL_STORAGE_KEYS } from 'config/Vars'
import { AvailableModules, Features } from 'generated/featureDefinitions'
import { useLocalStorage } from 'usehooks-ts'

import { observer } from 'mobx-react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { useEnabledFeatures } from 'modules/shift_management/hooks/useEnabledFeatures'
import automaticPlanningImg from 'modules/shift_management/lib/assets/automatic-planning.png'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

import RunAutoScheduleButton from './RunAutoScheduleButton'

interface Props {}

const AutoScheduleButton = ({}: Props) => {
  const [{ hasFeatureEntitlement }] = useEnabledFeatures()
  const { company } = useCurrentSession()
  const isLegacy = company.subscription.isLegacy ?? false
  const requestReason = isLegacy ? ValidReasons.MissingFeatureLegacy : ValidReasons.MissingFeature

  const isAutomationEnabled = hasFeatureEntitlement(Features.shift_management_automatic_planning)

  const [hasSeenNewEntryFlowHints] = useLocalStorage<boolean>(
    LOCAL_STORAGE_KEYS.shiftManagementHasSeenNewEntryFlowHints,
    false
  )
  if (!isAutomationEnabled)
    return (
      <UpsellingKit.ProductWidgetPopover
        label={i18n.t('shift_management.coverage_section.automation.button_title')}
        title={i18n.t('shift_management.hints.auto_schedule.title')}
        description={i18n.t('shift_management.hints.auto_schedule.description')}
        moduleRequested={AvailableModules.shift_management}
        featureRequested={Features.shift_management_automatic_planning}
        requestSource="auto_schedule_modal"
        pageSource="shift_management_table_header"
        requestReason={requestReason}
        variant="outlinePromote"
        mediaUrl={automaticPlanningImg}
        side="bottom"
      />
    )
  if (hasSeenNewEntryFlowHints) return <RunAutoScheduleButton />

  return (
    <Hint.Popover
      step={2}
      title={i18n.t('shift_management.hints.auto_schedule.title')}
      description={i18n.t('shift_management.hints.auto_schedule.description')}
      actionLabel={i18n.t('common.next')}
      position="bottom left"
    >
      <RunAutoScheduleButton />
    </Hint.Popover>
  )
}

export default observer(AutoScheduleButton)
